import React, { useState } from 'react'
import styled from 'styled-components'

const StyledDownUp = styled.div`
  word-break: break-all;
`

/** 文本展开 */
export const TextReadMore: React.FC<{
  text: string
  limit: number
  style?: React.CSSProperties
  className?: string
  /** moren自定义样式 */
  renderMore?: () => React.ReactNode
}> = ({ text, limit, style, className, renderMore }) => {
  const [showFullText, setShowFullText] = useState(false)

  return (
    <StyledDownUp className={className} style={style}>
      {showFullText ? (
        <>{text}</>
      ) : (
        <>
          {text.length >= limit ? (
            <>
              {text?.substring(0, limit) + '...'}{' '}
              <span
                className=" cursor-pointer"
                onClick={() => setShowFullText(true)}
              >
                {renderMore ? (
                  renderMore()
                ) : (
                  <span className="text-primary cursor-pointer">查看更多</span>
                )}
              </span>
            </>
          ) : (
            <>{text}</>
          )}
        </>
      )}
    </StyledDownUp>
  )
}
